import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Col, Row, Space } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { selectConfig, selectConfigActionEvent, selectConfigEvent } from 'Store/pos/selector'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { AppTextArea } from 'Components/form'
import { LoadingView } from 'Components/modal'
import { GetConfigReq, SetConfigReq } from 'Store/pos/types'
import { getConfigAPI, setConfigAPI } from 'Store/pos/api'
import { clearEventAction } from 'Store/pos/actions'
import { MyTheme } from 'Components/common/Theme'
import AppMultiSelect from 'Components/form/AppMultiSelect'
import { DocumentConfigKey, menuDeliveryHeader, menuDeliverySignType } from 'helpers/constanst'
import { PrimaryButton } from 'Components/button'
import { getDefaultValueConfig } from 'helpers/format'

type Props = {} & ReduxProps

const DeliveryConfig: React.FunctionComponent<Props> = props => {
  const { currentUser, actionEvent, event, configData } = props
  const dispatch = useDispatch()
  const [documentrRemark, setDocumentrRemark] = useState('')
  const [documentSignature, setDocumentSignature] = useState([] as any[])
  const [documentHeader, setDocumentHeader] = useState([] as any[])
  const key = DocumentConfigKey.DELIVERY

  useEffect(() => {
    onGetConfig()
  }, [])

  useEffect(() => {
    if (configData) {
      const data = configData && configData?.config_value && JSON.parse(configData?.config_value || '')
      setDocumentrRemark(data?.remark || '')
      setDocumentSignature(data?.signature || getDefaultValueConfig(menuDeliverySignType))
      setDocumentHeader(data?.header || [])
    }
  }, [configData])

  const onGetConfig = () => {
    const req: GetConfigReq = {
      config: key,
    }
    dispatch(getConfigAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onUpdateConfig = () => {
    const configValue = {
      remark: documentrRemark,
      signature: documentSignature,
      header: documentHeader,
    }
    const req: SetConfigReq = {
      config_name: key,
      config_type: 'string',
      config_value: JSON.stringify(configValue),
    }
    dispatch(setConfigAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onUpdateSuccess = (): void => {
    clearEvent()
    onGetConfig()
  }

  return (
    <>
      <Row gutter={[32, 24]}>
        <Col md={12} xs={24}>
          <Row>
            <Col span={24}>
              <Title>ตั้งค่าตัวเลือกหัวกระดาษ (เลือกได้หลายรายการ หรือพิมพ์หัวข้อที่ต้องการเพิ่ม)</Title>
            </Col>
            <Col md={24} xs={24}>
              <AppMultiSelect
                name="discount_type"
                label=""
                isRequired={false}
                isError={false}
                value={documentHeader || []}
                onChange={value => {
                  setDocumentHeader(value)
                }}
                menu={menuDeliveryHeader}
              />
            </Col>
            <Col span={24}>
              <Title>ตั้งค่าหมายเหตุเอกสาร (ท้ายกระดาษ)</Title>
            </Col>
            <Col md={24} xs={24}>
              <AppTextArea
                label=""
                isRequired={false}
                isError={false}
                name="address"
                rows={4}
                value={documentrRemark}
                onChange={val => setDocumentrRemark(val)}
              />
            </Col>
            <Col span={24}>
              <Title>ตั้งค่าช่องลายเซ็น (เลือกได้หลายรายการ หรือพิมพ์ชื่อที่ต้องการเพิ่ม)</Title>
            </Col>
            <Col md={24} xs={24}>
              <AppMultiSelect
                name="discount_type"
                label=""
                isRequired={false}
                isError={false}
                value={documentSignature || []}
                onChange={value => {
                  setDocumentSignature(value)
                }}
                menu={menuDeliverySignType}
              />
            </Col>
            <Col md={24} xs={24}>
              <Space size="middle" align="baseline">
                <PrimaryButton text="บันทึกข้อมูล" onClick={onUpdateConfig} />
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>

      <EventModal
        event={[actionEvent]}
        enable={true}
        successCalback={onUpdateSuccess}
        errorCalback={clearEvent}
      />
      <LoadingView isShow={event.IsLoading} />
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    actionEvent: selectConfigActionEvent(state),
    event: selectConfigEvent(state),
    configData: selectConfig(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const Title = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-bottom: 10px;
`

export default connect(mapStateToProps)(DeliveryConfig)
